import { Component, Input, OnInit, OnDestroy, EventEmitter, Output, Inject } from "@angular/core";
import { CommonService } from "../../_services/common.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";
import { FlashMessagesService } from "angular2-flash-messages";
import * as Materialize from 'materialize-css';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
export interface DialogData {
  name: string;
  message: string;
  manageData: any;
}

@Component({
  selector: 'app-client-address-form',
  templateUrl: './client-address-form.component.html',
  styleUrls: ['./client-address-form.component.css']
})
export class ClientAddressFormComponent implements OnInit {
  clientAddressForm: FormGroup;
  @Input() userId: any;
  @Input() addressId: any;
  @Output() toggleForm = new EventEmitter<string>();
  public countryList: Array<any> = [];
  public selectedCountry: any;
  loading = false;
  navigationSubscription;
  constructor(private fb: FormBuilder,
    private flashMessagesService: FlashMessagesService,
    private CommonService: CommonService,
    private CommonProjectDataService: CommonProjectDataService,
    private router: Router,
    private activateroute: ActivatedRoute,
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.navigationSubscription = this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
    this.clientAddressForm = this.fb.group({
      name: [null],
      email: [null, Validators.email],
      phone: [null],
      address1: [null, Validators.required],
      address2: [null],
      city: [null, Validators.required],
      state: [null, Validators.required],
      zip: [null, Validators.required],
      country: [null, Validators.required]
    })
  }

  ngOnInit() {
    this.countryList = this.CommonProjectDataService.getCountryList();
    if (this.countryList.length > 0) {
      this.selectedCountry = this.countryList[0].countryCode;
    }
    if (this.addressId != null) {
      this.getAddressList(this.addressId);
    }
    else {
      this.clientAddressForm.reset;
    }

  }

  ngAfterViewInit() {
    Materialize.updateTextFields();
  }

  getAddressList = function (id) {
    this.loading = true;
    this.CommonService.apiService(
      "GET",
      "user/address/" + id
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          if (response.data) {
            this.clientAddressForm.setValue({
              'name': response.data.name,
              'email': response.data.email,
              'phone': response.data.phone,
              'address1': response.data.address1,
              'address2': response.data.address2,
              'city': response.data.city,
              'state': response.data.state,
              'zip': response.data.zip,
              'country': response.data.country ? response.data.country : ''

            });
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  saveAddressFormData = function (postData) {

    if (this.clientAddressForm.valid) {
      this.loading = true;
      let apiMethod: string;
      var formData = new FormData();
      formData.append('name', postData.name);
      formData.append('address1', postData.address1);
      formData.append('address2', postData.address2);
      formData.append('city', postData.city);
      formData.append('state', postData.state);
      formData.append('zip', postData.zip);
      formData.append('country', postData.country);
      formData.append('phone', postData.phone);
      formData.append('email', postData.email);
      formData.append('id', this.userId);

      if (this.userId != null) {
        formData.append('id', this.userId);
        apiMethod = "user/address/create";
      }
      if (this.addressId != null) {
        formData.append('id', this.addressId);
        apiMethod = "user/address/edit";
      }

      this.CommonService.apiService(
        "POST",
        apiMethod,
        formData
      ).subscribe(
        (response: any) => {
          if (response.status === true) {
            this.loading = false;
            // this.back(response.message);
            this.flashMessagesService.show(response.message, {
              cssClass: "alert-success",
              timeout: 5000
            });
            var obj = this;
            setTimeout(() => {
              obj.backToList();
            }, 2000);

          }
          window.scrollTo(0, 0);
        },
        err => {
          this.loading = false;
          console.log('error msg', err.error.message);
          this.flashMessagesService.show(err.error.message, {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
      );
    } else {
      this.validateAllFormFields(this.clientAddressForm);
    }
  };

  isFieldValid(field: string) {
    return (
      !this.clientAddressForm.get(field).valid &&
      this.clientAddressForm.get(field).touched
    );
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {

      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  // back(): void {
  //   this.clientAddressForm.reset;
  //   this.toggleForm.emit();
  // }

  backToList(): void {
    this.clientAddressForm.reset;
    this.toggleForm.emit("close");
  }

  // ngOnDestroy() {
  //   if (this.navigationSubscription) {
  //     this.navigationSubscription.unsubscribe();
  //   }
  // }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/client-address-form/client-address-form.component.ts